module.exports = __webpack_public_path__ + "static/img/manual-25.b802ee5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/manual-25.png
// module id = MFrZ
// module chunks = 4